/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CompareBy,
  Status,
  IFilter,
  PreviewFilter,
  CategoryFilter,
  IClassLine,
  IPolicy,
  ISectionFeatures,
  ISelectedClassCover,
  IComparisonOptions,
  IFeatureContents,
  ISelectionModal,
  IApprovePolicyModal,
  IBuyGroup,
  IImpersonation,
} from '../../types'
import { categories } from './data'

export interface IComparisonState {
  filterOpen: boolean
  filter: IFilter
  selectedProductClassCover: ISelectedClassCover | null
  selectedPolicyContents: IFeatureContents[] | []
  selectedSectionCovers: IFeatureContents[]
  productClasses: IClassLine[] | [] | null
  /**
   * Whether productClasses holds the catalogue the API returned, as opposed to the seed in
   * ./data it starts on. Anything deciding what a cover id means has to know the
   * difference — the seed is AU-only and frozen at the day it was written.
   */
  productClassesLoaded: boolean
  selectionModal: ISelectionModal
  approvePolicyModal: IApprovePolicyModal
  comparisonPolicies: IPolicy[] | [] | null
  comparisonFeatures: ISectionFeatures[] | []
  buyGroups: IBuyGroup[] | []
  impersonation: IImpersonation
  savedComparisons: any
  tmd: any
  comparisonOptions: IComparisonOptions | null
  /** The policies the last uploaded wording resolved to — one PDF can name several. */
  importedPdfData: IPolicy[] | null
  /**
   * Columns that are on screen but still waiting for their findings. An imported policy
   * takes its column as soon as the wording is matched, so the header is readable while
   * the comparison text is still in flight; this is what tells that column to say so.
   */
  importingPolicyIds: number[]
  comparisonStatus: Status
  comparisonError: string | null
}

export const initialState: IComparisonState = {
  filterOpen: false,
  filter: {
    preview: PreviewFilter.ICON,
    category: CategoryFilter.ALL,
    showNew: true,
    showDifferences: false,
    onlyWhatsNew: false,
    showLimitsOnly: false,
    compareBy: CompareBy.COMPANY,
    effectiveDate: null,
    // effectiveDate: moment(new Date()).format(DateFormat.UTC),
    searchFeature: '',
    filterFeature: {},
    filterPolicy: {},
    // On by default: the picker lists each policy's most recently expired wording unless
    // the user unticks Show expired.
    showExpiredInPicker: true,
  },
  productClasses: categories,
  productClassesLoaded: false,
  selectionModal: { open: false },
  approvePolicyModal: { open: false },
  comparisonPolicies: [],
  comparisonFeatures: [],
  comparisonOptions: null,
  selectedPolicyContents: [],
  selectedSectionCovers: [],
  selectedProductClassCover: null,
  savedComparisons: [],
  tmd: [],
  buyGroups: [],
  impersonation: {
    selectedCountry: 'au',
    selectedBuyGroup: null,
    countryBuyGroupOptions: [],
  },
  importedPdfData: null,
  importingPolicyIds: [],
  comparisonStatus: Status.IDLE,
  comparisonError: null,
}
